import { AvailabilityColumns } from '@miq/catalog';
export const filterTypes = {
  availFromTim: 'searchAvailFromTim',
  enquiryFromAvail: 'searchEnquiryFromAvail',
};
export const preserveFilterKeys = [
  'property.property_usage.lig_geography.market_desc',
  'target_geography.lig_geography/market_desc',
  'ref_space_availability_status_desc',
];
export const preserveFilterKeyIds = [
  AvailabilityColumns.Property_Market,
  AvailabilityColumns.SpaceDetails_AvailabilityStatus,
];
/**
 * Some catalog-sourced filter entries come back shaped as a raw column definition (`columnId`,
 * possibly a string) rather than the resolved IOption shape (`key` as a number) other filters
 * use - coerce to Number and check both fields.
 */
export const isPostalCodeFilter = (filter: { key?: any; columnId?: any }): boolean =>
  Number(filter?.key ?? filter?.columnId) === AvailabilityColumns.Property_PostalCode;
